package org.solyton.solawi.bid.module.style.page

import org.jetbrains.compose.web.css.*

val verticalPageStyle: StyleScope.()->Unit = {
    paddingTop(24.px)
    paddingLeft(24.px)
    paddingRight(24.px)
    paddingBottom(24.px)
}
